<template>
    <v-dialog content-class="mt-5 v-dialog--custom" v-model="showDialog" persistent scrollable>
        <v-card>
            <v-card-title class="bg-gray-light">
                <span class="text-h5 label-black">{{ title }}</span>
                <v-btn @click="closeDialog" class="ml-auto" icon>
                    <v-icon id="close-button">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-tabs v-model="tab" style="background-color:gainsboro !important;" centered icons-and-text>
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab href="#tab-1">
                        <p style="color: black;">{{ $t("exportData.csv") }}</p>
                    </v-tab>
                    <v-tab href="#tab-2">
                        <p style="color: black;">{{ $t("exportData.report") }}</p>
                    </v-tab>
                    <v-tab :disabled="isDeviceVPS || this.isTableChartVPS()" href="#tab-3">
                        <p style="color: black;">{{ $t("exportData.graph") }}</p>
                    </v-tab>
                    <v-tab v-if="isDeviceTorasute" href="#tab-4">
                        <p style="color: black;">{{ $t("exportData.pdf") }}</p>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab" style="min-height: 450px;">
                    <!-- Tab1 -->
                    <v-tab-item key="1" value="tab-1">
                        <v-card flat>
                            <v-card-text
                                style="border:1px solid black; margin-top:5px !important;padding-top: 0px !important;padding-bottom: 0px !important;">
                                <!-- Type  -->
                                <div class="m-1">
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-4 col-4 input-group input-group-sm">
                                            <span class="input-group-addon mb-1 label-black">{{
                                                    $t("exportData.sortByDate")
                                            }}</span>
                                        </div>
                                        <div class="input-group-append justify-content-center">
                                            <v-radio-group v-model="orderBy" row>
                                                <div style="min-width: 300px" class="col-xl-4 col-lg-4 col-4">
                                                    <v-radio style="margin-right:100px !important;" key="1"
                                                        label="Ascending" value="asc">
                                                        <template v-slot:label>
                                                            <span class="radioLabel label-black">{{ $t("exportData.asc")
                                                            }}</span>
                                                        </template>
                                                    </v-radio>
                                                </div>
                                                <div style="min-width: 300px" class="col-xl-4 col-lg-4 col-4">
                                                    <v-radio key="2" label="Descending" value="desc">
                                                        <template v-slot:label>
                                                            <span class="radioLabel label-black">{{
                                                                    $t("exportData.desc")
                                                            }}</span>
                                                        </template>
                                                    </v-radio>
                                                </div>
                                            </v-radio-group>
                                        </div>

                                    </div>
                                    <div v-if="this.isTableChartTs() || isTableTs || isDeviceTsOrSimilarTs(deviceCode)" class="row">
                                        <div class="col-xl-4 col-lg-4 col-4 input-group input-group-sm">
                                            <span class="input-group-addon mb-1 label-black">{{
                                                    $t("exportData.csvDisplayOption")
                                            }}</span>
                                        </div>
                                        <v-radio-group v-model="csvDisplayOption" row>
                                            <div style="min-width: 300px" class="col-xl-4 col-lg-4 col-4">
                                                <v-radio key="1" label="vertical" value="vertical">
                                                    <template v-slot:label>
                                                        <span class="radioLabel">{{ $t("exportData.vertical") }}</span>
                                                    </template>
                                                </v-radio>
                                            </div>
                                            <div style="min-width: 300px" class="col-xl-4 col-lg-4 col-4">
                                                <v-radio key="2" label="horizonral" value="horizonral">
                                                    <template v-slot:label>
                                                        <span class="radioLabel">{{ $t("exportData.horizonral")
                                                        }}</span>
                                                    </template>
                                                </v-radio>
                                            </div>
                                        </v-radio-group>
                                    </div>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <!-- Tab2 -->
                    <v-tab-item key="2" value="tab-2">
                        <v-card flat>
                            <v-card-text
                                style="border:1px solid black; margin-top:5px !important;padding-top: 0px !important;padding-bottom: 0px !important;">
                                <div class="row m-1">
                                    <div style="padding-top: 0px !important;padding-bottom: 0px !important;"
                                        class="col-xl-12 col-lg-12 col-12">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 label-black" style="min-width: 9em;">{{
                                                    $t("exportData.sortByDate")
                                            }}</span>
                                        </div>
                                        <div class="input-group-append justify-content-center">
                                            <v-radio-group v-model="orderBy" row>
                                                <v-radio style="margin-right:100px !important;" key="1"
                                                    label="Ascending" value="asc">
                                                    <template v-slot:label>
                                                        <span class="radioLabel label-black">{{ $t("exportData.asc")
                                                        }}</span>
                                                    </template>
                                                </v-radio>
                                                <v-radio key="2" label="Descending" value="desc">
                                                    <template v-slot:label>
                                                        <span class="radioLabel label-black">{{ $t("exportData.desc")
                                                        }}</span>
                                                    </template>
                                                </v-radio>
                                            </v-radio-group>
                                        </div>

                                    </div>
                                </div>

                            </v-card-text>
                            <v-card-text style="border:1px solid black; margin-top:5px !important;">
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.reportTitle")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field class="inputContent-report" v-model="reportTitle" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.siteId")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field class="inputContent-report" v-model="SiteIdInput" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.siteName")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field class="inputContent-report" v-model="SiteNameInput" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.adminSiteName")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field class="inputContent-report" v-model="projectAdministrator" hide-details="auto" outlined
                                                dense></v-text-field>
                                        </div>
                                    </div>
                                </div>

                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- Tab3 -->
                    <v-tab-item key="3" value="tab-3">
                        <v-card flat>
                            <v-card-text style="border:1px solid black; margin-top:5px !important;">
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.siteId")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field v-model="SiteIdInput" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.siteName")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field v-model="SiteNameInput" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3 splitNumber">
                                        <div class="input-group input-group-sm splitNumber">
                                            <span class="input-group-addon mb-1 labelInput label-black splitNumber">{{
                                                    $t("exportData.splitNumber")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-text-field class="splitNumber-graph" type="number"
                                                onKeyPress="if(this.value.length==5) return false;"
                                                oninput="if(this.value < 1 || this.value.length === 0 ) this.value = 1;if(this.value > 99 ) this.value = 99;"
                                                v-model="splitNumber" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-12 splitNumberMoreDetail">
                                        <span class="input-group-addon mb-1 labelInput label-black splitNumberMoreDetail">{{
                                                        $t("exportData.splitNumberMoreDetail")
                                        }}</span>
                                    </div>
                                </div>
                                <div v-if="this.isTableChartTs() || isTableTs || isDeviceTsOrSimilarTs(deviceCode)" class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.min")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-6">
                                        <div class="input-group input-group-sm">
                                            <v-select v-model="displayScaleMin" value="displayScaleMin" type="number"
                                                suffix="mm" :items="displayScaleDropdown" dense outlined>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="this.isTableChartTs() || isTableTs || isDeviceTsOrSimilarTs(deviceCode)" class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.max")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-6">
                                        <div class="input-group input-group-sm">
                                            <v-select v-model="displayScaleMax" value="displayScaleMax" type="number"
                                                suffix="mm" :items="displayScaleDropdown" dense outlined>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="this.isTableChartTs() || isTableTs || isDeviceTsOrSimilarTs(deviceCode)" class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.auxiliaryLine")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-6">
                                        <div class="input-group input-group-sm">
                                            <v-select v-model="auxiliaryLine" suffix="mm" :items="auxiliaryLineDropdown"
                                                dense outlined>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row m-1">
                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.thresholdLegend")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-checkbox v-model="thresholdLegendCheck">
                                                <template v-slot:label>
                                                    <span class="radioLabel label-black">{{
                                                            $t("exportData.thresholdLegendMsg")
                                                    }}</span>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-3">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.ngOption")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-9 col-lg-9 col-9">
                                        <div class="input-group input-group-sm">
                                            <v-checkbox v-model="ngCheck">
                                                <template v-slot:label>
                                                    <span class="radioLabel label-black">{{
                                                            $t("exportData.ngText")
                                                    }}</span>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!-- Tab4 -->
                    <v-tab-item key="4" value="tab-4">
                        <v-card flat>
                            <v-card-text style="border:1px solid black; margin-top:5px !important;">
                                <div class="row m-1">
                                    <div class="col-xl-4 col-lg-4 col-4">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.TimePdf")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-lg-8 col-8">
                                        <div class="input-group input-group-sm">
                                            <v-select
                                                v-model="modelExportPdf.timePdfSelectBox" 
                                                :items="formattedItems"
                                                :multiple="true"
                                                item-text="label" item-value="value" 
                                                hide-details="auto" outlined dense
                                                @change="handleSelectChange"
                                                chips
                                                :error="checkTimePdf()"
                                            >
                                                <template v-if="modelExportPdf.timePdfSelectBox.length > 0" v-slot:selection="{ item, index }"> 
                                                    <template v-if="modelExportPdf.timePdfSelectBox.filter(x => x !== 'all').length <= 2"> 
                                                        <v-chip :key="index" > {{ item.label }} </v-chip> 
                                                    </template> <template v-else-if="index === 0"> 
                                                        <v-chip class="ma-2"> {{ modelExportPdf.timePdfSelectBox.filter(x => x !== 'all').length }} {{ $t("exportData.itemSelect") }}</v-chip> 
                                                    </template> 
                                                </template>
                                            </v-select>
                                        </div>
                                        <span class="text-danger" v-if="isSaving && modelExportPdf.timePdfSelectBox.length == 0">{{ $t("exportData.TimePdf") + ERROR_CODE['IS_REQUIRED'] }}</span>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-4 col-lg-4 col-4">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">{{
                                                    $t("exportData.siteId")
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-lg-8 col-8">
                                        <div class="input-group input-group-sm">
                                            <v-text-field v-model="modelExportPdf.siteID" maxlength="200" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-4 col-lg-4 col-4">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">
                                                {{$t("exportData.siteName")}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-lg-8 col-8">
                                        <div class="input-group input-group-sm">
                                            <v-text-field v-model="modelExportPdf.siteName" maxlength="200" hide-details="auto" outlined dense>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-4 col-lg-4 col-4">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">
                                                {{$t("exportData.constructionLocation")}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-lg-8 col-8" style="align-self: center;">
                                        <div class="input-group input-group-sm">
                                            <div class="w-100 d-flex">
                                                <div class="" style="width: 48%;">
                                                    <div class="row input-date-mg-ip">
                                                        <div class="col-xl-12 col-lg-12 col-12">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field maxlength="200" v-model="modelExportPdf.constructionLocationFrom" hide-details="auto" outlined dense v-bind="attrs" v-on="on">
                                                                    </v-text-field>
                                                                    </template>
                                                                <span>{{ modelExportPdf.constructionLocationFrom }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width: 8%;" class="d-lg-flex justify-content-center sign-ipad sign-iphone">
                                                    <b class="m-0 mt-1" style="font-size: 20px;">〜</b>
                                                </div>
                                                <div class="" style="width: 48%;">
                                                    <div class="row justify-content-end input-date-mg-ip">
                                                        <div class="col-xl-12 col-lg-12 col-12 pl-3 input-end-date">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field maxlength="200" v-model="modelExportPdf.constructionLocationTo" hide-details="auto" outlined dense v-bind="attrs" v-on="on">
                                                                    </v-text-field>
                                                                    </template>
                                                                <span>{{ modelExportPdf.constructionLocationTo }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <div class="col-xl-4 col-lg-4 col-4">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-addon mb-1 labelInput label-black">
                                                {{$t("exportData.adminSite")}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xl-8 col-lg-8 col-8" style="align-self: center;">
                                        <div class="input-group input-group-sm">
                                            <div class="w-100 d-flex">
                                                <div class="" style="width: 80%;">
                                                    <div class="row input-date-mg-ip">
                                                        <div class="col-xl-12 col-lg-12 col-12">
                                                            <v-text-field v-model="modelExportPdf.adminSite" maxlength="200" hide-details="auto" outlined dense>
                                                            </v-text-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width: 20%; justify-content: end; align-self: center;" class="d-lg-flex sign-ipad sign-iphone">
                                                    <v-checkbox v-model="modelExportPdf.checkPrint" style="padding-left: 10px;">
                                                        <template v-slot:label>
                                                            <span class="radioLabel label-black">印</span>
                                                        </template>
                                                    </v-checkbox>
                                                    <!-- <v-btn depressed color="primary" style="background-color: #3d76ad"
                                                        @click="createItemTablePdf">
                                                        <v-icon color="white" size="20" class="mr-2 dark mt-0">
                                                            mdi-plus-box
                                                        </v-icon>
                                                        <span style="font-size: 17px" class="font-weight-bold">{{$t("labels.add")}}</span>
                                                    </v-btn> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <v-data-table style="width: 100%; max-height: 240px; overflow: hidden; overflow-y: auto;" :headers="headersPdf" :items="modelExportPdf.dataTablePdf" disable-pagination
                                        class="elevation-2 table-Frame" mobile-breakpoint="0" fixed-header locale="ja" hide-default-header
                                        hide-default-footer :footer-props="{
                                        'items-per-page-options': [200]
                                        }"
                                    >
                                        <template slot="no-data">
                                        {{ $t("notification.noData") }}
                                        </template>
                                        <template #header="{ props: { headers } }">
                                            <thead>
                                                <tr>
                                                    <th v-for="header in headers" :key="header.value" class="text-uppercase" scope="col">
                                                        {{ $t(header.text) }}
                                                    </th>
                                                </tr>
                                            </thead>
                                        </template>
                                        <template v-slot:[`item.station`]="{ item, index }">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field maxlength="200" v-model="item.station" :error="isDuplicateStation(index)"
                                                        outlined dense hide-details="true" v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                            <span>{{ item.station }}</span>
                                            </v-tooltip>
                                        </template>
                                        <template v-slot:[`item.location`]="{ item }">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field maxlength="200" v-model="item.location"
                                                        outlined dense hide-details="true" v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                </template>
                                                <span>{{ item.location }}</span>
                                            </v-tooltip>
                                        </template>
                                        <template v-slot:[`item.remarks`]="{ item }">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field maxlength="200" v-model="item.remarks" 
                                                        outlined dense hide-details="true" v-bind="attrs" v-on="on">
                                                    </v-text-field>
                                                    </template>
                                                <span>{{ item.remarks }}</span>
                                            </v-tooltip>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>
                <!-- <div style="width:2100px; height: 400px;" ref="tagMain" class="card-body chart_hidden">
                    <v-chart ref="chart" :option="{}" class="chart" autoresize />
                </div> -->

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!checkDetail" class="text-white mr-1" @click="onExportToFile()"
                    style="background-color: #3d76ad" text>{{
                            $t("exportData.export")
                    }}
                </v-btn>
                <v-btn class="bg-secondary text-white" text @click="closeDialog">
                    {{ $t("labels.systemUserManager.cancel") }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog content-class="mt-5 v-dialog--custom exportGraph-preview" v-model="showDialogPreview" :max-width="2100" :width="2100"
            persistent>
            <v-card>
                <v-card-title class="bg-gray-light">
                    <span class="text-h5 label-black">{{ $t("exportData.graphPreview") }}</span>
                    <v-btn @click="showDialogPreview = false" class="ml-auto" icon>
                        <v-icon id="close-button">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div>
                    <div style="color:black;font-weight: bold; font-size: 16px" ref="titlePdf"
                        class="sheet padding-10mm">
                        <div>{{ titlePdfPreview }}</div>
                        <div>{{ labelTimePreview }}</div>
                    </div>
                    <div class="exportGraph-previewChart">
                        <div style="width:1800px; height: 400px;" ref="tagMain" class="card-body">
                            <v-chart ref="chartPreview" :option="{}" :initOptions="initOpts" @finished="onFinishedChart"
                                class="chartPreview" :autoresize="true"/>
                        </div>
                    </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart } from "echarts/charts";
import {
    ToolboxComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { UniversalTransition } from "echarts/features";
import { EventBus } from '@/utils/eventBus.js'
import { mapActions } from 'vuex';
import {
    getCookieSiteUser,
    setCurrentPageCode
} from "@/utils/auth";
import axios from "axios";
import jsPDF from 'jspdf';
import { getDeviceBySite } from '@/api/device';
import { ResponseCode } from "@/constants/constants"
import $ from 'jquery';
import { langEN } from "@/languages/echarts/langEN.js";
import { langJA } from "@/languages/echarts/langJA.js";
import fontNotoSansJP from '@/assets/fonts/NotoSansJP-Regular.ttf';
// import { amiriFont } from "@/assets/fonts/amiriFont.js";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import 'jspdf-autotable';
import dayjs from "dayjs";
use([
    ToolboxComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    LineChart,
    CanvasRenderer,
    UniversalTransition,
]);

export default {
    name: "ExportModal",
    props: [
        'visible',
        'titleModal',
        'deviceCode',
        'startDate',
        'endDate',
        'displayInterval',
        'stationSelectedLst',
        'displayIntervalList',
        'TsConfigCheck',
        'MValue',
        'ThresholdValue',
        'valueStationMainTS',
        'tsStationSearch',
        'orgNoSearch',
        'FrameType',
        'FrameId',
        'headers',
        'frameName',
        'deviceTSList',
        'isTableTs',
        'deviceListByFrame',
        'isDeviceVPS',
        'deviceVPSList'
    ],
    components: {
        VChart
    },
    data() {
        $('#main-header').css("pointer-events", "");
        return {
            loading: false,
            orderBy: "asc",
            csvDisplayOption: "vertical",
            detailOption: "1",
            tab: 1,
            title: "",
            showDialog: false,
            checkDetail: false,
            editMode: false,
            showPassword: false,
            showIconEye: false,
            deviceSelected: '',
            reportTitle: null,
            projectAdministrator: null,
            SiteIdInput: null,
            SiteNameInput: null,
            thresholdLegendCheck: false,
            ngCheck: false,
            PAGE_CODE: 'CS_DS',
            dataChartFake: [],
            showDialogPreview: false,
            initOpts: {
                locale: 'JA'
            },
            isFinishOneChart: false,
            splitNumber: 5,
            titlePdfPreview: null,
            labelTimePreview: null,
            displayScaleMin: -10,
            displayScaleMax: 10,
            displayScaleDropdown:
                [
                    { text: '1000', value: 1000 },
                    { text: '900', value: 900 },
                    { text: '800', value: 800 },
                    { text: '700', value: 700 },
                    { text: '600', value: 600 },
                    { text: '500', value: 500 },
                    { text: '400', value: 400 },
                    { text: '300', value: 300 },
                    { text: '200', value: 200 },
                    { text: '150', value: 150 },
                    { text: '100', value: 100 },
                    { text: '50', value: 50 },
                    { text: '45', value: 45 },
                    { text: '40', value: 40 },
                    { text: '35', value: 35 },
                    { text: '30', value: 30 },
                    { text: '25', value: 25 },
                    { text: '20', value: 20 },
                    { text: '15', value: 15 },
                    { text: '10', value: 10 },
                    { text: '5', value: 5 },
                    { text: '4', value: 4 },
                    { text: '3', value: 3 },
                    { text: '2', value: 2 },
                    { text: '1', value: 1 },
                    { text: '0', value: 0 },
                    { text: '-1', value: -1 },
                    { text: '-2', value: -2 },
                    { text: '-3', value: -3 },
                    { text: '-4', value: -4 },
                    { text: '-5', value: -5 },
                    { text: '-10', value: -10 },
                    { text: '-15', value: -15 },
                    { text: '-20', value: -20 },
                    { text: '-25', value: -25 },
                    { text: '-30', value: -30 },
                    { text: '-35', value: -35 },
                    { text: '-40', value: -40 },
                    { text: '-45', value: -45 },
                    { text: '-50', value: -50 },
                    { text: '-100', value: -100 },
                    { text: '-150', value: -150 },
                    { text: '-200', value: -200 },
                    { text: '-300', value: -300 },
                    { text: '-400', value: -400 },
                    { text: '-500', value: -500 },
                    { text: '-600', value: -600 },
                    { text: '-700', value: -700 },
                    { text: '-800', value: -800 },
                    { text: '-900', value: -900 },
                    { text: '-1000', value: -1000 }],
            auxiliaryLine: 5,
            auxiliaryLineDropdown:
                [{ text: '±1', value: 1 },
                { text: '±2', value: 2 },
                { text: '±5', value: 5 },
                { text: '±10', value: 10 },
                { text: '±20', value: 20 },
                { text: '±50', value: 50 },
                { text: '±100', value: 100 }
            ],
            isDeviceTorasute: false,
            DataSelectPdf: [],
            previousSelection: [],
            headersPdf: [
                {text: '#', sortable: false, value: 'index', align: 'center', width: "50"},
                {text: this.$t('exportData.headerpdf.station'), value: 'station', sortable: false, align: 'center'},
                {text: this.$t('exportData.headerpdf.location'), sortable: false, value: 'location', align: 'center'},
                {text: this.$t('exportData.headerpdf.remarks'), value: 'remarks', sortable: false, align: 'center'},
            ],
            dataTablePdf: [],
            modelExportPdf: {
                timePdfSelectBox: [],
                siteID: null,
                siteName: null,
                constructionLocationFrom: null,
                constructionLocationTo: null,
                adminSite: null,
                checkPrint: true,
                dataTablePdf: [],
            },
            ERROR_CODE: '',
            isSaving: false,
            requestSearch: {},
        }
    },
    created() {
        setCurrentPageCode(this.PAGE_CODE);
        EventBus.$on('handleOpenExport', (value) => {
            this.isDeviceTorasute = false;
            this.detailOption = "1";
            this.orderBy = "asc";
            this.csvDisplayOption = "vertical";
            this.reportTitle = null;
            let siteID = getCookieSiteUser();
            this.title = value.title;
            this.showDialog = value.flag;
            if (value.flag) {
                $('#main-header').css("pointer-events", "none");
            }
            else {
                $('#main-header').css("pointer-events", "");
            }
            this.checkDetail = value.checkDetail;
            this.editMode = value.editMode;
            this.deviceSelected = value.deviceSelected;
            this.SiteIdInput = siteID;
            this.SiteNameInput = value.allSiteData.find((ele) => ele.value == siteID).text;
            this.thresholdLegendCheck = false;
            this.ngCheck = false;
            this.splitNumber = 5;
            this.projectAdministrator = value.selectedUser.userName;
            this.tab = "tab-1";
            if((this.orgNoSearch === 100 && value.requestSearch.FrameId == null) || (this.orgNoSearch === 100 && value.requestSearch.FrameType == "TC")){
                this.isDeviceTorasute = true;
                this.requestSearch = value.requestSearch;
            }
            this.previousSelection = [];
            this.modelExportPdf = {
                timePdfSelectBox: [],
                siteID: null,
                siteName: null,
                constructionLocationFrom: null,
                constructionLocationTo: null,
                adminSite: null,
                checkPrint: true,
                dataTablePdf: []
            }
            this.isSaving = false;
            this.headersPdf = [
                {text: '#', sortable: false, value: 'index', align: 'center', width: "50"},
                {text: this.$t('exportData.headerpdf.station'), value: 'station', sortable: false, align: 'center'},
                {text: this.$t('exportData.headerpdf.location'), sortable: false, value: 'location', align: 'center'},
                {text: this.$t('exportData.headerpdf.remarks'), value: 'remarks', sortable: false, align: 'center'},
            ];
        });
    },
    computed: {
        formattedItems() {
            if(this.DataSelectPdf.length > 0){
                return [
                    { label: this.$t("exportData.all"), value: "all" },
                    ...this.DataSelectPdf,
                ];
            }
            return this.DataSelectPdf
        },
    },
    watch: {    
        '$i18n.locale': async function (currentLang) {
            await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
            .then((DATA) => {
                this.ERROR_CODE = DATA.ERROR_CODE
            })
            .catch(async () => {
                await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
                .then((DATA) => {
                    this.ERROR_CODE = DATA.ERROR_CODE
                })
            })
        },
        tab(newValue) {
            if (newValue === "tab-4") {
                // this.loadTableMasterPdf();
                this.loadSettingTorasute();
                this.loadDataTime();
            }
        },
    },
    async beforeMount() {
      const currentLang = this.$i18n.locale
      await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/deviceMaster/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
    },
    methods: {
        ...mapActions("report", {
            exportDataToFile: "exportDataToFile",
            exportDataToFilePDF: "exportDataToFilePDF",
            getDataDeviceTSGroupTime: "getDataDeviceTSGroupTime",
            getDataExPdfTorasute: "getDataExPdfTorasute",
        }),
        ...mapActions("warning", {
            getDataListTblMaster: "getDataListTblMaster",
            saveDataTblMaster: "saveDataTblMaster",
            getSettingTorasute: "getSettingTorasute"
        }),
        async onExportToFile() {
            let siteID = getCookieSiteUser();
            this.isSaving = true;
            // site id is not exist
            if (!siteID) {
                return;
            }
            if (this.deviceCode === null && this.FrameId === null) {
                return;
            }
            let exportType = "csv";
            if (this.tab === "tab-1") {
                exportType = "csv";
            }
            else if (this.tab === "tab-2") {
                exportType = "excel";
            }
            else if (this.tab === "tab-3") {
                exportType = "graph";
                if (this.isTableChartTs() || this.isTableTs || this.isDeviceTsOrSimilarTs(this.deviceCode)) {
                    if (this.displayScaleMin.value == undefined) {
                        this.displayScaleMin = parseInt(this.displayScaleMin);
                    }
                    else {
                        this.displayScaleMin = parseInt(this.displayScaleMin.value);
                    }
                    if (this.displayScaleMax.value == undefined) {
                        this.displayScaleMax = parseInt(this.displayScaleMax);
                    }
                    else {
                        this.displayScaleMax = parseInt(this.displayScaleMax.value);
                    }
                    if (this.displayScaleMin > this.displayScaleMax) {
                        this.commonNotifyVue(this.$t("exportData.warningMinMax"), 'warning');
                        return;
                    }
                    const range = this.displayScaleMax - this.displayScaleMin;
                    const currentCondition = range / this.auxiliaryLine;

                    if (currentCondition > 18) {
                        const validAuxiliaryLines = this.auxiliaryLineDropdown
                        .map(item => item.value)
                        .filter(value => range / value < 18);
                        
                        if (validAuxiliaryLines.length > 0) {
                            const suggestedAuxiliaryLine = Math.min(...validAuxiliaryLines);
                            var msgErr = this.$i18n.locale === 'en' ? 
                            `Please select a value of ±${suggestedAuxiliaryLine} or more for the auxiliary line` 
                            : `補助線の値が [±${suggestedAuxiliaryLine}] 以上を選択してください。`
                            this.commonNotifyVue(msgErr, 'warning');
                            return;
                        }
                    }
                    // if ((this.displayScaleMin + this.displayScaleMax) % 2 != 0) {
                    //     this.commonNotifyVue("Min + Max not even", 'warning');
                    //     return;
                    // }
                }
            }
            else if (this.tab === "tab-4"){
                exportType = "pdf";
                const hasError = this.modelExportPdf.dataTablePdf.some((item, index) =>
                    this.isDuplicateStation(index)
                );
                if(hasError){
                    this.commonErrorVue(this.ERROR_CODE['DATA_INVALID'], 'warning');
                    return
                }
                if(this.modelExportPdf.timePdfSelectBox.length > 0){
                    await this.saveTableMasterPdf();
                    this.exportPdfTorasute();
                }
                return;
            }
            var displayInterval = this.displayIntervalList.find(element => element.value === this.displayInterval);
            this.isSaving = false;
            let request = {
                "ExportType": exportType,
                "SiteId": siteID,
                "orderType": this.orderBy,
                "deviceCode": this.deviceCode,
                "locale": this.$i18n.locale,
                "reportTitle": this.reportTitle,
                "projectAdministrator": this.projectAdministrator,
                "startDate": this.startDate,
                "endDate": this.endDate,
                'interval': this.displayInterval,
                "SiteIdInput": this.SiteIdInput,
                "SiteNameInput": this.SiteNameInput,
                "stationSelectedLst": this.stationSelectedLst,
                "displayIntervalName": this.$i18n.locale === 'en' ? displayInterval.labelEN : displayInterval.labelJP,
                "tsConfigCheck": this.TsConfigCheck,
                "MValue": this.MValue,
                "ThresholdValue": this.ThresholdValue,
                "thresholdLegendCheck": this.thresholdLegendCheck === true ? 1 : 2,
                "splitNumber": this.splitNumber,
                "valueStationMainTS": this.valueStationMainTS,
                "tsStationSearch": this.tsStationSearch,
                "orgNoSearch": this.orgNoSearch,
                "csvDisplayOption": exportType == "csv" ? this.csvDisplayOption : "vertical",
                "FrameType": this.FrameType,
                "FrameId": this.FrameId,
                "SettingHeader": this.headers,
                "IsQuickExport": false,
                "MinimumValueOfAxis": (this.isTableChartTs() || this.isTableTs || this.isDeviceTsOrSimilarTs(this.deviceCode)) ? this.displayScaleMin : null,
                "MaximumValueOfAxis": (this.isTableChartTs() || this.isTableTs || this.isDeviceTsOrSimilarTs(this.deviceCode)) ? this.displayScaleMax : null
            }
            this.loading = true;
            // get device by site
            await getDeviceBySite(request).then(response => {
                if (response.data && response.data.code === ResponseCode.SUCCESS) {
                    this.deviceList = response?.data?.data;
                    for (let i = 0; i < this.deviceList.length; i++) {
                        if (this.deviceList[i].value == this.deviceCode) {
                            this.deviceName = this.$i18n.locale === 'en' ? this.deviceList[i].labelEN : this.deviceList[i].labelJP;
                        }
                    }
                } else {
                    this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                }
            }).catch(err => {
                if (err.code != undefined)
                    this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
            })
            if (exportType == "excel") {
                this.loading = true;
                this.downloadFileExcel(request);
            }
            else if (exportType == "csv") {
                this.exportDataToFile(request)
                    .then(response => {
                        if (exportType == "csv") {
                            this.downloadFileCsv(response);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
                    .finally(final => {
                        this.loading = false;
                    });
            }
            else if (exportType == "graph") {
                this.exportDataToFilePDF(request)
                    .then(response => {
                        if (response.code === ResponseCode.SUCCESS) {
                            this.downloadFilePdf(request, response);
                        }
                        else {
                            this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                            this.loading = false;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
                    .finally(final => {
                        this.loading = false;
                    });
            }
        },
        closeDialog() {
            // if(this.tab == 'tab-4'){
            //     this.commonConfirmVue(this.ERROR_CODE['CF_052_01_01'], () => {
            //         this.showDialog = false
            //         $('#main-header').css("pointer-events", "");
            //     });
            // }
            // else{
            //     this.showDialog = false;
            //     $('#main-header').css("pointer-events", "");
            // }
            this.showDialog = false;
            $('#main-header').css("pointer-events", "");
        },
        isDeviceTsOrSimilarTs(deviceCode){
            return this.deviceTSList !== null && this.deviceTSList.length > 0 && this.deviceTSList.includes(Number(deviceCode));
        },
        isTableChartTs() {
            const deviceLst = this.deviceListByFrame.map(x => Number(x.value));
            return deviceLst.length > 0 &&  deviceLst.every(r => this.deviceTSList.includes(r));
        },
        isTableChartVPS() {
            const deviceLst = this.deviceListByFrame.map(x => Number(x.value));
            return deviceLst.length > 0 && deviceLst.every(r => this.deviceVPSList.includes(r));
        },
        pad2(n) { return n < 10 ? '0' + n : n },
        downloadFileCsv(response) {
            const anchor = document.createElement('a');
            let date = new Date();
            let fileName = (this.FrameType === '0' ? this.deviceName : this.frameName) + "_" + date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds()) + ".csv"
            anchor.href = URL.createObjectURL(new Blob([response], { type: 'data:text/csv;charset=utf-8' }))
            anchor.target = '_blank';
            anchor.download = fileName;
            anchor.click();
            this.loading = false;
        },
        downloadFileExcel(request) {
            this.loading = true;
            // const token = getToken();
            // const CS_DS = "CS_DS";
            this.exportDataToFile(request).then((response) => {
                // const url = URL.createObjectURL(new Blob([response], {
                //     type: 'application/vnd.ms-excel;charset=utf-8'
                // }))
                // const link = document.createElement('a')
                // link.href = url
                let date = new Date();
                // let fileName = (this.FrameType === '0' ? this.deviceName : this.frameName) + "_" + date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds()) + ".xlsx"
                // link.setAttribute('download', fileName)
                // document.body.appendChild(link)
                // link.click()
                const blob = new Blob([response], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                let fileName = (this.FrameType === '0' ? this.deviceName : this.frameName) + "_" + date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds()) + ".xlsx"
                saveAs(blob, fileName);
            }).catch((error) => {
                console.log('[exportDataToFile]', error);
            }).finally(() => {
                this.loading = false;
            });
        },
        minChartTs(value) {
            return (this.isTableChartTs() || this.isTableTs || this.isDeviceTsOrSimilarTs(this.deviceCode)) ? ((this.displayScaleMin == 0 && this.displayScaleMax == 0) ? value.min : this.displayScaleMin) : undefined;
        },
        maxChartTs(value) {
            return (this.isTableChartTs() || this.isTableTs || this.isDeviceTsOrSimilarTs(this.deviceCode)) ? ((this.displayScaleMin == 0 && this.displayScaleMax == 0) ? value.max : this.displayScaleMax) : undefined;
        },
        async downloadFilePdf(request, response) {
            this.loading = true;
            var { titlePdf, labelTime } = response;
            var { splitNumber } = request;
            var dataChart = response.data;
            this.showDialogPreview = true;
            this.initOpts.locale = this.$i18n.locale === 'en' ? langEN : langJA;
            await this.sleep(1 * 500);
            let chart = this.$refs.chartPreview;
            try {
                // const fontBase64 = await this.loadFontAsBase64(fontNotoSansJP); 
                // const doc = new jsPDF({
                //     unit: "px",
                //     orientation: "landscape",
                //     hotfixes: ["px_scaling"]
                // });
                // doc.addFileToVFS('NotoSansJP-Regular.ttf', fontBase64); 
                // doc.addFont('NotoSansJP-Regular.ttf', 'NotoSansJP', 'normal'); 
                // doc.setFont('NotoSansJP');
                // const scale = 1/*window.devicePixelRatio;*/
                // const marginBottom = 25;
                // doc.setFontSize(12);

                // doc.text(titlePdf, 0, 20);
                // doc.text(labelTime, 0, 40);

                var groupBySubStation = this.groupBy(dataChart, 'subStation');
                // console.log("groupBySubStation ", groupBySubStation);
                if (Object.keys(groupBySubStation).length === 0) {
                    const fontBase64 = await this.loadFontAsBase64(fontNotoSansJP); 
                    const doc = new jsPDF({
                        unit: "px",
                        orientation: "landscape",
                        hotfixes: ["px_scaling"]
                    });
                    doc.addFileToVFS('NotoSansJP-Regular.ttf', fontBase64); 
                    doc.addFont('NotoSansJP-Regular.ttf', 'NotoSansJP', 'normal'); 
                    doc.setFont('NotoSansJP');
                    doc.setFontSize(12);

                    doc.text(titlePdf, 0, 20);
                    doc.text(labelTime, 0, 40);

                    var fileNamePdfNoData = (this.FrameType === '0' ? this.deviceName : this.frameName) + "_" + this.formatDate(new Date());
                    await doc.save(fileNamePdfNoData, {
                        returnPromise: true
                    });
                }
                for (const subStation in groupBySubStation) {
                    const fontBase64 = await this.loadFontAsBase64(fontNotoSansJP); 
                    const doc = new jsPDF({
                        unit: "px",
                        orientation: "landscape",
                        hotfixes: ["px_scaling"]
                    });
                    doc.addFileToVFS('NotoSansJP-Regular.ttf', fontBase64); 
                    doc.addFont('NotoSansJP-Regular.ttf', 'NotoSansJP', 'normal'); 
                    doc.setFont('NotoSansJP');
                    const scale = 1/*window.devicePixelRatio;*/
                    const marginBottom = 25;
                    doc.setFontSize(12);

                    doc.text(titlePdf, 0, 20);
                    doc.text(labelTime, 0, 40);
                    if (request.deviceCode !== "200" && request.deviceCode !== "300") {
                        var startY = 75;
                        if (groupBySubStation[subStation]) {
                            groupBySubStation[subStation][groupBySubStation[subStation].length - 1].isLastLine = true;
                        }
                        var groupByStationOther = this.groupBy(groupBySubStation[subStation], 'siteStationId');
                        for (const station in groupByStationOther) {

                            var dataChartOther = groupByStationOther[station]
                            var legendListOther = [];
                            var seriesListOther = [];
                            for (let index = 0; index < dataChartOther.length; index++) {
                                if (dataChartOther[index].data === undefined || dataChartOther[index].data === null || dataChartOther[index].data.length === 0) {
                                    continue;
                                }
                                let dataGraphOther = [];
                                let dataGraphNotNullOther = [];
                                var chartNameOther = this.makeLegendName(dataChartOther[index]);
                                for (const [key, value] of Object.entries(dataChartOther[index].data)) {
                                    const dateNumber = this.convertStringToDateNumber(key);
                                    dataGraphOther.push([dateNumber, value]);
                                    if(value !== null){
                                        dataGraphNotNullOther.push(value);
                                    }
                                }
                                var isNoDataOther = (dataGraphNotNullOther.length === 0);
                                var seriesObjOther = {
                                    data: dataGraphOther,
                                    type: "line",
                                    name: chartNameOther,
                                    showSymbol: false,
                                    color: this.isDevice200or300(dataChartOther[index].deviceCode) ? this.getColor200ByDataCode(dataChartOther[index].dataCode) : '#0000ff',
                                    connectNulls: !this.ngCheck
                                }
                                legendListOther.push(chartNameOther);
                                seriesListOther.push(seriesObjOther);
                                if (!this.isDevice200or300(dataChartOther[index].deviceCode) || (this.isDevice200or300(dataChartOther[index].deviceCode) && dataChartOther[index].isBreakPage)) {
                                    var dataChartOtherW = [];
                                    if (!this.isDevice200or300(dataChartOther[index].deviceCode)){
                                        dataChartOtherW.push(dataChartOther[index]);
                                    } else {
                                        dataChartOtherW = dataChartOther;
                                    }
                                    for (let j = 0; j < dataChartOtherW.length; j++) {
                                        const warningLst = dataChartOtherW[j].warningData;
                                        warningLst.forEach(element => {
                                            var elementType = this.isDevice200or300(dataChartOther[index].deviceCode) ? element.type.split("_")[0] : element.type;
                                            legendListOther.push(elementType);
                                            var warning = {
                                                data: Object.keys(dataChartOtherW[j].data).map((key) => { return [this.convertStringToDateNumber(key), element.value] }),
                                                type: "line",
                                                name: elementType,
                                                showSymbol: false,
                                                symbolSize: 0,
                                                color: element.color,
                                            }
                                            seriesListOther.push(warning);
                                        });
                                    }
                                    await chart.setOption({
                                        animation: false,
                                        // tooltip: {
                                        //     trigger: 'axis',
                                        //     position: function (pt) {
                                        //         return [pt[0], '10%'];
                                        //     }
                                        // },
                                        textStyle: {
                                            color: "black",
                                            fontSize: 12
                                        },
                                        backgroundColor: "#fff",
                                        legend: { data: legendListOther },
                                        xAxis: {
                                            type: 'time',
                                            boundaryGap: false,
                                            splitLine: {
                                                interval: 1,
                                                show: true,
                                                lineStyle: {
                                                    type: "dotted",
                                                    color: "black"
                                                }
                                            },
                                            axisTick: { show: false },
                                            axisLabel: {
                                                fontSize: 12,
                                                formatter: {
                                                    year: '{yearStyle|{yyyy}/{MM}}',
                                                    month: '{MMM}',
                                                    day: '{MM}/{dd}',
                                                    hour: '{HH}:{mm}',
                                                    minute: '{HH}:{mm}',
                                                    second: '{HH}:{mm}:{ss}',
                                                    millisecond: '{hh}:{mm}:{ss} {SSS}',
                                                    none: '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss} {SSS}'
                                                },
                                                rich: {
                                                    yearStyle: {
                                                        // Make yearly text more standing out
                                                        color: '#000',
                                                        fontWeight: 'bold'
                                                    }
                                                }
                                            },
                                            axisLine: {
                                                lineStyle: {
                                                    color: 'black',
                                                    width: 2,
                                                },
                                                show: false
                                            },
                                            splitNumber: splitNumber
                                        },
                                        yAxis: {
                                            name: dataChartOther[index].unit,
                                            type: 'value',
                                            boundaryGap: [0, '100%'],
                                            nameTextStyle: {
                                                color: "black",
                                                fontSize: 12,
                                                fontWeight: "bold",
                                            },
                                            splitLine: {
                                                show: true,
                                                lineStyle: {
                                                    type: "solid",
                                                    color: ['#000000']
                                                }
                                            },
                                            axisLabel: {
                                                fontSize: 12,
                                                fontWeight: "bold"
                                            },
                                            interval: dataChartOther[index].isDeviceTs ? this.auxiliaryLine : undefined,
                                            min: dataChartOther[index].minYAxis ?? (isNoDataOther ? 0 : this.minChartTs()),
                                            max: dataChartOther[index].maxYAxis ?? (dataChartOther[index].deviceCode == 100 && dataChartOther[index].dataMapping == "data5" ? 400 : (isNoDataOther ? 100 : this.maxChartTs()))
                                        },
                                        series: seriesListOther
                                    });
                                    await this.sleep(1 * 300);
                                    let img = null;
                                    if (this.isFinishOneChart) {
                                        img = await this.getChartImage(chart);
                                    }
                                    var w = 1760 / (scale * 1.5);
                                    var h = this.isDevice200or300(dataChartOther[index].deviceCode) ? (360 / (scale * 1.25)) : (360 / (scale * 1.75));
                                    doc.addImage(img.src, "JPG", 0, startY, w, h);
                                    legendListOther = [];
                                    seriesListOther = [];
                                    chart.clear();
                                    startY = startY + (360 / (scale * 1.75)) + marginBottom;
                                    if ((startY > 605 || dataChartOther[index].isBreakPage) && !dataChartOther[index].isLastLine) {
                                        startY = 25;
                                        doc.addPage();
                                    }
                                }

                            }

                        }
                        // this.showDialogPreview = false;
                    }
                    else {
                        var startY200 = 125;
                        var groupByStation = this.groupBy(dataChart, 'siteStationId');
                        for (const station in groupByStation) {
                            var legendList = [];
                            var seriesList = [];
                            var dataChart200300 = groupByStation[station]
                            for (let index = 0; index < dataChart200300.length; index++) {
                                if (dataChart200300[index].data === undefined || dataChart200300[index].data === null || dataChart200300[index].data.length === 0) {
                                    continue;
                                }
                                var chartName200 = this.makeLegendName(dataChart200300[index]);
                                let dataGraphNotNull200 = [];
                                let dataGraph200 = [];
                                for (const [key, value] of Object.entries(dataChart200300[index].data)) {
                                    const dateNumber = this.convertStringToDateNumber(key);
                                    dataGraph200.push([dateNumber, value]);
                                    if(value !== null){
                                        dataGraphNotNull200.push(value);
                                    }
                                }
                                var isNoData200 = (dataGraphNotNull200.length === 0);
                                var seriesObj = {
                                    data: dataGraph200,
                                    type: "line",
                                    name: chartName200,
                                    showSymbol: false,
                                    color: this.getColor200ByDataCode(dataChart200300[index].dataCode),
                                    connectNulls: !this.ngCheck
                                }
                                legendList.push(chartName200);
                                seriesList.push(seriesObj);
                            }
                            for (let index = 0; index < dataChart200300.length; index++) {
                                const warningLst = dataChart200300[index].warningData;
                                warningLst.forEach(element => {
                                    legendList.push(element.type);
                                    var warning = {
                                        data: Object.keys(dataChart200300[index].data).map((key) => { return [this.convertStringToDateNumber(key), element.value] }),
                                        type: "line",
                                        name: element.type,
                                        showSymbol: false,
                                        symbolSize: 0,
                                        color: element.color,
                                    }
                                    seriesList.push(warning);
                                });

                            }
                            await chart.setOption({
                                animation: false,
                                // tooltip: {
                                //     trigger: 'axis',
                                //     position: function (pt) {
                                //         return [pt[0], '10%'];
                                //     }
                                // },
                                textStyle: {
                                    color: "black",
                                    fontSize: 12
                                },
                                backgroundColor: "#fff",
                                legend: {
                                    data: legendList,
                                },
                                xAxis: {
                                    type: 'time',
                                    boundaryGap: false,
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            type: "dotted",
                                            color: "black"
                                        }
                                    },
                                    axisLabel: {
                                        formatter: {
                                            year: '{yearStyle|{yyyy}/{MM}}',
                                            month: '{MMM}',
                                            day: '{MM}/{dd}',
                                            hour: '{HH}:{mm}',
                                            minute: '{HH}:{mm}',
                                            second: '{HH}:{mm}:{ss}',
                                            millisecond: '{hh}:{mm}:{ss} {SSS}',
                                            none: '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss} {SSS}'
                                        },
                                        rich: {
                                            yearStyle: {
                                                // Make yearly text more standing out
                                                color: '#000',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    splitNumber: splitNumber
                                },
                                yAxis: {
                                    name: dataChart200300[0].unit,
                                    type: 'value',
                                    boundaryGap: [0, '100%'],
                                    nameTextStyle: {
                                        color: "black",
                                        fontSize: 12,
                                        fontWeight: "bold",
                                    },
                                    splitLine: {
                                        show: true,
                                        lineStyle: {
                                            type: "dotted",
                                            color: "black"
                                        }
                                    },
                                    axisLabel: {
                                        fontSize: 12,
                                        // color: "red",
                                        fontWeight: "bold",
                                    },
                                    min: (isNoData200 ? 0 : undefined),
                                    max: (isNoData200 ? 100 : undefined)
                                },
                                series: seriesList
                            });
                            if (seriesList !== undefined && seriesList !== null && seriesList.length > 0) {
                                await this.sleep(1 * 300);
                                let img = null;
                                if (this.isFinishOneChart) {
                                    img = await this.getChartImage(chart);
                                }
                                // doc.text(550, 100, dataChart200300[0].siteStationId);
                                doc.addImage(img.src, "JPG", 0, startY200, 1760 / (scale * 1.5), 360 / (scale * 1.25));
                                chart.clear();
                                startY200 = startY200 + (360 / (scale * 1.75)) + marginBottom;
                                doc.addPage();
                                if (startY200 > 655) {
                                    startY200 = 25;
                                    doc.addPage();
                                }
                            }
                            if (doc.internal.getNumberOfPages() === 0)
                                doc.addPage();
                        }
                        //delete last page
                        var pageCount = doc.internal.getNumberOfPages();
                        doc.deletePage(pageCount)
                        this.showDialogPreview = false;
                    }
                    var fileNamePdf = (this.FrameType === '0' ? this.deviceName : this.frameName) + "_" + this.formatDate(new Date());
                    await doc.save(fileNamePdf, {
                        returnPromise: true
                    });
                }


                this.loading = false;
                this.showDialogPreview = false;
            } catch (e) {
                console.error("failed to export", e);
                this.loading = false;
            }
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');
            var hours = String(date.getHours()).padStart(2, '0');
            var minutes = String(date.getMinutes()).padStart(2, '0');
            var seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        convertStringToDateNumber(dateStr) {
            var d1 = dateStr.split(" ");
            var date = d1[0].split("/");
            var time = d1[1].split(":");
            var dd = parseInt(date[2]);
            var mm = parseInt(date[1] - 1);
            var yyyy = parseInt(date[0]);
            var hh = parseInt(time[0]);
            var min = parseInt(time[1]);
            var ss = parseInt(time[2]);
            var fromdt = +new Date(yyyy, mm, dd, hh, min, ss);
            return fromdt;
        },
        isDevice200or300(deviceCode) {
            return deviceCode == 200 || deviceCode == 300;
        },
        getColor200ByDataCode(dataCode) {
            switch (dataCode) {
                case "vibration_value_max":
                    return "#ff9900";
                case "vibration_value_10":
                    return "#867456";
                case "vibration_value_50":
                    return "#ff00ff";
                case "vibration_value_90":
                    return "#0000ff";
                case "noise_value_max":
                    return "#ff9900";
                case "noise_value_5":
                    return "#867456";
                case "noise_value_50":
                    return "#ff00ff";
                case "noise_value_95":
                    return "#0000ff";
                default:
                    return "red";
            }

        },
        makeLegendName(dataChart) {
            var siteStationIdOther = dataChart.siteStationName;
            var dataNameOther = this.$i18n.locale === 'en' ? dataChart.nameEn : dataChart.nameJp;
            var chartNameOther = null;
            if (dataChart.channelNo != null && dataChart.channelName != null) {
                chartNameOther = dataChart.channelName + "_" + siteStationIdOther;
            } else if (dataChart.isDeviceTs) {
                chartNameOther = dataNameOther + "(" + `${dataChart.subStation}-${dataChart.subNumber}` + ")";
            } else {
                chartNameOther = siteStationIdOther + "_" + dataNameOther;
            }
            return chartNameOther;
        },
        loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
            });
        },
        getChartImage(chart) {
            return this.loadImage(chart.getDataURL());
        },
        onFinishedChart() {
            this.isFinishOneChart = true;
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        handleSelectChange(selectedValues) {
            const hasAllInPrevious = this.previousSelection.includes("all");
            const hasAllInCurrent = selectedValues.includes("all");
            if (hasAllInCurrent && !hasAllInPrevious) {
                this.modelExportPdf.timePdfSelectBox = this.formattedItems.map((item) => item.value);
            } else if (hasAllInPrevious && !hasAllInCurrent) {
                this.modelExportPdf.timePdfSelectBox = [];
            } else {
                var allItems = this.DataSelectPdf.map((item) => item.value);
                var listSplitAll = selectedValues.filter(x => x !== "all");
                if (listSplitAll.length === this.DataSelectPdf.length) {
                    this.modelExportPdf.timePdfSelectBox = ["all", ...allItems];
                } else {
                    this.modelExportPdf.timePdfSelectBox = selectedValues.filter((value) => value !== "all");
                }
            }
            this.previousSelection = [...this.modelExportPdf.timePdfSelectBox];
        },
        createItemTablePdf(){
            var newItem = {};
            newItem.index = this.modelExportPdf.dataTablePdf.length + 1;
            newItem.station = null;
            newItem.location = null;
            newItem.remarks = null;
            this.modelExportPdf.dataTablePdf.push(newItem);
        },
        isDuplicateStation(index) {
            if (!this.isSaving) return false; 
            const value = this.modelExportPdf.dataTablePdf[index].station;
            if(value != null && value != undefined && value.trim() !== ''){
                const duplicates = this.modelExportPdf.dataTablePdf.filter(
                    (item, idx) => idx !== index && item.station === value
                );
                return duplicates.length > 0;
            }
            return false
        },
        checkTimePdf(){
            if (!this.isSaving) return false; 
            return this.modelExportPdf.timePdfSelectBox.length == 0;
        },
        // loadTableMasterPdf(){
        //     var request = {
        //         deviceCode: this.deviceCode,
        //         siteId: this.requestSearch.siteId
        //     }
        //     this.getDataListTblMaster(request)
        //     .then(response => {
        //         if (response.code === 0) {
        //             this.modelExportPdf.dataTablePdf = response.data.map((item, index) => ({
        //             index: index + 1,
        //             station: item.station,
        //             location: item.location,
        //             remarks: item.remarks
        //         }));
        //         } else {
        //             this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err);
        //         if(err.code != undefined)
        //             this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
        //     })
        // },
        saveTableMasterPdf(){
            if(this.modelExportPdf.dataTablePdf.length > 0){
                var request = {
                    deviceCode: this.deviceCode,
                    siteId: this.requestSearch.siteId,
                    siteIdPrint: this.modelExportPdf.siteID,
                    siteName: this.modelExportPdf.siteName,
                    locationFrom: this.modelExportPdf.constructionLocationFrom,
                    locationTo: this.modelExportPdf.constructionLocationTo,
                    adminSiteName: this.modelExportPdf.adminSite,
                    checkPrint: this.modelExportPdf.checkPrint,
                    listData: this.modelExportPdf.dataTablePdf.filter(x => x.station != null && (typeof x.station !== 'string' || x.station.trim() !== ''))
                    .map(item => ({
                        station: item.station,
                        location: item.location,
                        remarks: item.remarks
                    }))
                }
                this.saveDataTblMaster(request);
            }
        },
        loadDataTime(){
            this.loading = true;
            this.requestSearch.language = this.$i18n.locale;
            this.getDataDeviceTSGroupTime(this.requestSearch).then(response => {
                if (response.code === 0) {
                    this.DataSelectPdf = response.data.dataTime.map(item => {
                        return {
                            value: item.time,
                            label: item.time
                        };
                    });
                    this.modelExportPdf.dataTablePdf = response.data.dataTblMaster.map((item, index) => ({
                        index: index + 1,
                        station: item.station,
                        location: item.location,
                        remarks: item.remarks
                    }));
                } else {
                    this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                }
            })
            .catch(err => {
                console.log(err);
                if(err.code != undefined)
                    this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
            }).finally(final => {
                this.loading = false;
            });
        },
        loadSettingTorasute(){
            var request = {
                deviceCode: this.requestSearch.deviceCode,
                siteId: this.requestSearch.siteId,
            } 
            this.getSettingTorasute(request).then(response => {
                if (response.code === 0) {
                    if(response.data){
                        this.modelExportPdf.siteID = response.data.siteIdPrint;
                        this.modelExportPdf.siteName = response.data.siteName;
                        this.modelExportPdf.constructionLocationFrom = response.data.locationFrom;
                        this.modelExportPdf.constructionLocationTo = response.data.locationTo;
                        this.modelExportPdf.checkPrint = response.data.printChecked;
                        this.modelExportPdf.adminSite = response.data.adminSite;
                    }
                    else{
                        this.modelExportPdf.siteID = this.SiteIdInput;
                        this.modelExportPdf.siteName = this.SiteNameInput;
                        this.modelExportPdf.adminSite = this.projectAdministrator;
                        this.modelExportPdf.checkPrint = true;
                    }
                }
            })
        },
        exportPdfTorasute(){
            this.loading = true;
            if(this.modelExportPdf.timePdfSelectBox.length > 0){
                var repuest = {
                    siteId: this.requestSearch.siteId,
                    deviceCode: this.requestSearch.deviceCode,
                    frameType: this.requestSearch.FrameType,
                    FrameId: this.requestSearch.FrameId,
                    stationSelectedLst: this.requestSearch.stationSelectedLst,
                    valueStationMainTS: this.requestSearch.valueStationMainTS,
                    orgNoSearch: this.requestSearch.orgNoSearch,
                    displayInterval: this.requestSearch.displayInterval,
                    tsStationSearch: this.requestSearch.tsStationSearch,
                    listTime: this.modelExportPdf.timePdfSelectBox.filter(x => x !== 'all'),
                    listSettingTable: this.modelExportPdf.dataTablePdf.map(item => ({
                        station: item.station,
                        location: item.location,
                        remarks: item.remarks
                    }))
                }
                this.getDataExPdfTorasute(repuest).then(response => {
                    if (response.code === 0) {
                        this.templateExportTorasute(response.data, response.headers);
                    } else {
                        this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
                        this.loading = false;
                    }
                })
                .catch(err => {
                    console.log(err);
                    if(err.code != undefined){
                        this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
                        this.loading = false;
                    }
                })
            }
        },
        async loadFontAsBase64(fontPath) {
            const response = await fetch(fontPath);
            if (!response.ok) {
                throw new Error(`Can not download font from ${fontPath}`);
            }
            const fontBuffer = await response.arrayBuffer();
            try {
                const base64 = this.arrayBufferToBase64(fontBuffer);
                return base64;
            } catch (error) {
                console.error("Error during Base64 conversion:", error);
                throw error;
            }
        },
        arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const chunkSize = 1024; 
            for (let i = 0; i < bytes.length; i += chunkSize) {
                const chunk = bytes.slice(i, i + chunkSize);
                binary += String.fromCharCode(...chunk);
            }
            return btoa(binary);
        },
        async templateExportTorasute(data, header) { 
            try { 
                var nameFile = this.$t("exportData.fileExportPdf.fileName"); 
                const zip = new JSZip(); 
                const fontBase64 = await this.loadFontAsBase64(fontNotoSansJP); 
                const createPdfDoc = async (item) => { 
                    const doc = new jsPDF(); 
                    doc.addFileToVFS('NotoSansJP-Regular.ttf', fontBase64); 
                    doc.addFont('NotoSansJP-Regular.ttf', 'NotoSansJP', 'normal'); 
                    doc.setFont('NotoSansJP');

                    const lineHeight = 8;  // Chiều cao dòng
                    const margin = 10;  
                    const spaceBetweenSections = 12;  // Khoảng cách đều giữa các phần
                    const pageWidth = doc.internal.pageSize.width;
                    const usableWidth = pageWidth - 2 * margin; 
                    const square = '■';

                    // Tiêu đề
                    doc.setFontSize(14);  
                    const text = this.$t("exportData.fileExportPdf.title");
                    const textWidth = doc.getTextWidth(text);
                    const textX = (pageWidth - textWidth) / 2;
                    const textY = 20;
                    doc.text(text, textX, textY);
                    doc.line(textX, textY + 3, textX + textWidth, textY + 3);

                    // Bắt đầu vẽ nội dung dưới tiêu đề
                    doc.setFontSize(10);
                    let currentY = textY + lineHeight + spaceBetweenSections;

                    // 🔹 **Site ID & Site Name**
                    const textSiteId = square + this.$t("exportData.fileExportPdf.siteID") + ': ' + (this.modelExportPdf.siteID || '');
                    const textSiteName = square + this.$t("exportData.fileExportPdf.siteName") + ': ' + (this.modelExportPdf.siteName || '');

                    // Chia tỷ lệ: Site ID 40% - Site Name 60%
                    const colWidthSiteId = (pageWidth - 2 * margin) * 0.35;
                    const colWidthSiteName = (pageWidth - 2 * margin) * 0.65;

                    // Xuống dòng nếu quá dài
                    const wrappedTextSiteId = doc.splitTextToSize(textSiteId, colWidthSiteId);
                    const wrappedTextSiteName = doc.splitTextToSize(textSiteName, colWidthSiteName);

                    // Vị trí in
                    doc.text(wrappedTextSiteId, margin, currentY);
                    doc.text(wrappedTextSiteName, margin + colWidthSiteId + 10, currentY); // Cách 10 đơn vị so với Site ID

                    // Điều chỉnh Y để tránh chồng chữ
                    currentY += Math.max(wrappedTextSiteId.length, wrappedTextSiteName.length) * lineHeight;

                    // Gạch chân sát chữ
                    doc.line(margin, currentY - 6, pageWidth - margin, currentY - 6);

                    // 🔹 **Construction Location**
                    currentY += spaceBetweenSections;
                    const textCl = square + this.$t("exportData.fileExportPdf.constructionLocation") + ': ' + (this.getValueConstructionlocation() || '');
                    const wrappedTextCl = doc.splitTextToSize(textCl, usableWidth);

                    doc.text(wrappedTextCl, margin, currentY);
                    currentY += wrappedTextCl.length * lineHeight;

                    // Gạch chân
                    doc.line(margin, currentY - 6, pageWidth - margin, currentY - 6);

                    // 🔹 **Time, Admin Site Name, Print**
                    currentY += spaceBetweenSections;

                    // Nội dung
                    const textTime = square + this.$t("exportData.fileExportPdf.time") + ': ' + (this.formatTimePdf(item.time, this.$i18n.locale) || '');
                    const textAdminSite = square + this.$t("exportData.fileExportPdf.adminSiteName") + ': ' + (this.modelExportPdf.adminSite || '');
                    const textPrint = this.modelExportPdf.checkPrint ? this.$t("exportData.fileExportPdf.checkPrint") : '';

                    // Chia tỷ lệ: Time 40% - Admin Site Name + Print 60%
                    const colWidthTime = (pageWidth - 2 * margin) * 0.35;
                    const colWidthAdminPrint = (pageWidth - 2 * margin) * 0.65;

                    // Tính chiều rộng Print
                    const printWidth = doc.getTextWidth(textPrint);
                    const printX = pageWidth - margin - printWidth;

                    // Admin Site Name nằm giữa, cách Print 10 đơn vị
                    const maxAdminSiteWidth = printX - (margin + colWidthTime) - 10;
                    const wrappedTextAdminSite = doc.splitTextToSize(textAdminSite, maxAdminSiteWidth);

                    // Vị trí các phần tử
                    doc.text(textTime, margin, currentY); // Time (40%)
                    doc.text(wrappedTextAdminSite, margin + colWidthTime + 10, currentY); // Admin Site Name ngay sau Time
                    doc.text(textPrint, printX, currentY); // Print nằm bên phải

                    // Điều chỉnh Y để tránh chồng chữ
                    currentY += Math.max(wrappedTextAdminSite.length, 1) * lineHeight;

                    // Gạch chân sát chữ
                    doc.line(margin, currentY - 6, pageWidth - margin, currentY - 6);

                    // Add Table
                    const addTable = (page, isFirstPage) => { 
                        const tableHeader = [this.$t("exportData.fileExportPdf.station"), this.$t("exportData.fileExportPdf.location"), ...header.map(h => this.$i18n.locale === 'en' ? h.nameEn : h.nameJp ), this.$t("exportData.fileExportPdf.remarks")]; 
                        const tableData = item.listData.filter(data => data.page === page).map(data => { 
                            const rowData = [
                                { content: (data.station || ''), styles: { halign: 'center', fillColor: [255, 255, 255]} }, 
                                { content: (data.location || ''), styles: { halign: 'center', fillColor: [255, 255, 255] } }, 
                                ...header.map(h => {
                                    const value = data.data[h.dataMapping];
                                    const isNumber = typeof value === 'number' || (!isNaN(value) && value.trim && value.trim() !== ''); 
                                    return {
                                        content: value,
                                        styles: { halign: isNumber ? 'right' : 'center', fillColor: [255, 255, 255] }
                                    };
                                }),
                                { content: (data.remarks || ''), styles: { halign: 'left', fillColor: [255, 255, 255] } } ];
                            return rowData; 
                        }); 
                        const lastContentY = currentY + lineHeight + 5;
                        const tableY = isFirstPage ? lastContentY : (doc.previousAutoTable ? doc.previousAutoTable.finalY + 10 : 20);
                        // Adjust as needed 
                        doc.autoTable({ 
                            head: [tableHeader], 
                            body: tableData, 
                            startY: tableY, 
                            margin: { left: margin, right: margin }, 
                            styles: { font: "NotoSansJP", cellPadding: 3, lineWidth: 0.1, lineColor: [0, 0, 0], fillColor: [255, 255, 255] },
                            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center', valign: 'middle' },
                            tableLineColor: [0, 0, 0], 
                            tableLineWidth: 0.1,
                            columnStyles: { 
                                0: { cellWidth: 18, halign: 'center' }, 
                                1: { cellWidth: 22, halign: 'center' }, 
                                [tableHeader.length - 1]: { cellWidth: 40, halign: 'center' } 
                            }, 
                        }); 
                    };

                    // Add data to table based on pages 
                    const pages = [...new Set(item.listData.map(d => d.page))]; 
                    pages.forEach((page, index) => { 
                        if (index > 0) { 
                            doc.addPage(); 
                            addTable(page, false);
                        } 
                        else { 
                            addTable(page, true); 
                        } 
                    });

                    var fileName = nameFile + "_" + this.formatDate(new Date(item.time)) + ".pdf";
                    return { blob: doc.output('blob'), fileName: fileName };
                }; 
                if (data.length === 1) { 
                    const { blob, fileName } = await createPdfDoc(data[0]); 
                    saveAs(blob, fileName); 
                    this.loading = false; 
                    this.loadDataTime();
                } else { 
                    for (const item of data) { 
                        const { blob, fileName } = await createPdfDoc(item); 
                        zip.file(fileName, blob); 
                    } 
                    const zipBlob = await zip.generateAsync({ type: 'blob' }); 
                    saveAs(zipBlob, `${nameFile}.zip`); 
                    this.loading = false;
                    this.loadDataTime();
                }
            } catch (e) { 
                console.error("Failed to export", e); 
                this.loading = false; 
            } 
        },

        formatTimePdf(time, locale) {
            if (!time) return ''; 
            const formattedTime = locale === 'en'
                ? dayjs(time).format('YYYY/MM/DD HH:mm:ss') 
                : dayjs(time).format('YYYY年MM月DD日 HH時mm分ss秒'); 
            return formattedTime;
        },

        getValueConstructionlocation(){
            if(this.modelExportPdf.constructionLocationFrom != null && this.modelExportPdf.constructionLocationFrom?.trim().length != 0 
            && this.modelExportPdf.constructionLocationTo != null && this.modelExportPdf.constructionLocationTo?.trim().length != 0){
                return this.modelExportPdf.constructionLocationFrom + '〜' + this.modelExportPdf.constructionLocationTo
            }
            else{
                return this.modelExportPdf.constructionLocationFrom != null && this.modelExportPdf.constructionLocationFrom?.trim().length != 0 ? this.modelExportPdf.constructionLocationFrom : '' 
                + this.modelExportPdf.constructionLocationTo != null && this.modelExportPdf.constructionLocationTo?.trim().length != 0 ? this.modelExportPdf.constructionLocationTo : ''
            }
        }
    }
}
</script>
<style scoped lang="scss">
@font-face {
    font-family: "Amiri";
    src: local("Amiri"),
        url('http://fonts.cdnfonts.com/css/amiri') format("truetype");
}

.labelInput {
    min-width: 9em;
    padding: 10px !important;
}

.cell_min-width {
    min-width: 200px;
}

.v-card__actions {
    border-top: 1px solid #ebebeb;
}

.v-input--selection-controls {
    margin-top: 0px !important;
}

.radioLabel {
    margin-top: 8px !important;
    font-weight: 100;
    color: black;
}

.chart_hidden {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: -1;
}

.label-black {
    color: black !important;
}

.v-dialog--custom {
    max-width: 1000px;
    width: 800px;
}

@media (max-width: 820px) {
    .v-dialog--custom {
        overflow-y: unset !important;
    }
}

@media (max-width: 1180px) {
    .v-dialog--custom {
        padding-top: 60px;
        max-width: 800px;
        width: 800px;
    }

    .v-dialog--custom {
        overflow-x: unset !important;
    }
}
@media (min-width: 1000px) and (max-width: 1200px) {
    .input-date-mg-ip {
        margin-left: 0px !important;
    }

    .input-end-date {
        padding-left: 6px !important;
    }
}

::v-deep{
    .v-dialog--custom {
        max-width: 1000px;
        width: 800px;
    }
    .v-autocomplete .v-select__selections {
        word-break: break-all;
    }
    .splitNumber {
        padding-bottom: 0 !important;
    }
    .splitNumberMoreDetail {
        padding-top: 0 !important;
        padding-left: 6rem !important;
    }
    @media only screen and (max-width: 500px) and (max-height: 1000px) and (orientation: portrait){
        .v-dialog {
            overflow-y: auto !important;
        }
        .v-slide-group__wrapper{
            position: initial;
            margin-left: -1rem !important;
        }
        .labelInput{
            margin-left: -2.5rem !important;
        }
        .inputContent-report {
            margin-bottom: 0.1rem !important;
        }
        .exportGraph-previewChart {
            overflow: auto;
            width: 100%;
        }
        .v-card {
            margin-top: 5.5rem !important;
        }
        .v-input__control {
            padding-left: 1rem !important;
            min-width: 9rem !important;
        }
    }
}
::v-deep{
  .v-dialog {
    box-shadow: none !important;
  }
  .v-card__title {
    margin-top: 1.25rem !important;
  }
}
</style>
